import React from 'react';
import './Popultypebulbs.css';
import Ledlam from '../../../imgs/Ledlamp.webp';

const Popultypebulbs = () => {
    return (
        <div className="Generallyin-container">
            <div className='Cavitys'>
                <h2 className="Generallyin-title">Common and popular types of LED bulbs are the following</h2>
                <p className="Generallyin-date">A Series</p>
                <p className="Generallyin-tex">
                    one of the commonly used bulb shapes for general lighting,
                    the models are A15-A95, the wattage is 3W-20 W,
                    and the common sizes are A15, A19, A21, and A23.</p>
                <p className="Generallyin-date">G Series</p>
                <p className="Generallyin-tex"> bulbs have a round and substantially spherical shape
                    with a lower surface brightness than A Series bulbs.</p>
                <p className="Generallyin-date">T Series </p>
                <p className="Generallyin-tex">A tall, narrow tubular shape commonly used in old Edison- style light bulbs</p>
                <p className="Generallyin-date">B series</p>
                <p className="Generallyin-tex"> lamps represent the blunt series or the protruding series,
                    and they are usually used as decorative lamps and holiday lamps.</p>
                <p className="Generallyin-date">R Series </p>
                <p className="Generallyin-tex">bulbs are slightly more expensive
                    than some other types of bulbs and are designed to illuminate specific items or surfaces.</p>
                <p className="Generallyin-date">BR Series </p>
                <p className="Generallyin-tex">B-series and R-series combined retrofit lamps are BR-series lamps,
                    these lamps also have a reflective coating inside.</p>
                <p className="Generallyin-date">PS Series</p>
                <p className="Generallyin-tex">Pear-shaped lamps are very similar to A Series bulbs.</p>

                <div className="Generallyin">
                    <img src={Ledlam} alt="72 Generallyin PET Preforms Machine" className="Generallyin-image" />
                </div>
            </div>

        </div>
    );
};

export default Popultypebulbs;
